<h1 mat-dialog-title>
  <ng-container i18n="Profile Details Modal|Profile Details Modal title@@profile-details-modal-title">
    User Profile Details
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <permission-checker [roles]="roles" (rolesLoaded)="callerRolesUpdated($event)">
    <div>
      <form [formGroup]="profileDetailsForm" class="profile-details-form">
        <form-input [control]="emailField"
                    label="Email"
                    i18n-label="Sign Up|Email input label@@sign-up-email-label"
                    placeholder="Your email..."
                    i18n-placeholder="Sign Up|Email input placeholder@@sign-up-email-placeholder"
                    [suffixButton]="emailChangeAllowed ? 'person_search' : undefined"
                    [suffixAction]="searchUserByEmail"
                    (focusLost)="searchUserByEmail()"
                    autocomplete="email"
                    type="email"
                    [required]="emailRequired"
                    [minLength]="5" [maxLength]="128"
                    [class.text-disabled-color]="emailCheckInProgress"
                    [inProgress]="emailCheckInProgress"></form-input>
        <form-input *ngIf="showPhoneField"
                    [control]="phoneField"
                    type="tel"
                    label="Phone"
                    i18n-label="Sign Up|Phone input label@@sign-up-phone-label"
                    placeholder="Your phone (format like +380000000000)..."
                    i18n-placeholder="Sign Up|Phone input placeholder@@sign-up-phone-placeholder"
                    [minLength]="7" [maxLength]="15"></form-input>
        <form-input [control]="firstNameField"
                    [required]="false"
                    label="First Name"
                    i18n-label="Sign Up|First Name input label@@sign-up-first-name-label"
                    placeholder="First name..."
                    i18n-placeholder="Invite User Modal|First Name input placeholder@@invite-user-modal-first-name-placeholder"
                    [minLength]="2" [maxLength]="128"></form-input>
        <form-input [control]="lastNameField"
                    [required]="false"
                    label="Last Name"
                    i18n-label="Sign Up|Last Name input label@@sign-up-last-name-label"
                    placeholder="Last name..."
                    i18n-placeholder="Invite User Modal|Last Name input placeholder@@invite-user-modal-last-name-placeholder"
                    [minLength]="2" [maxLength]="128"></form-input>

        <mat-spinner *ngIf="schoolDataLoading" color="primary" diameter="40" class="center"></mat-spinner>
        <school-select *ngIf="!schoolDataLoading && (selectedSchool || selectedRegion)"
                       [roles]="roles"
                       [selectedGrade]="selectedGrade"
                       [selectedRegion]="selectedRegion"
                       [selectedSchoolType]="selectedType"
                       [selectedSchool]="selectedSchool"
                       [allowRegionSelect]="allowRegionSelect"
                       [allowSchoolTypeSelect]="allowSchoolTypeSelect"
                       [allowGradeSelect]="allowGradeSelect"
                       [allowSchoolSelect]="allowSchoolSelect"
                       [showGrade]="showGradeSelect"
                       [showRegion]="showRegionSelect"
                       [showSchool]="showSchoolSelect"
                       [clearSchoolAfterSelect]="false"
                       [allowSchoolClear]="allowSchoolSelect"
                       (gradeSelected)="selectedGrade = $event.grade"
                       (regionSelected)="selectedRegion = $event"
                       (schoolSelected)="selectedSchool = $event.school"></school-select>
      </form>
    </div>

  </permission-checker>
</div>
<div mat-dialog-actions>
  <span class="mat-small warn-block" [class.mobile]="mobileView">
    <mat-icon class="color-orange warn-icon">warning_amber</mat-icon>
    <span class="word-wrap-word"
          i18n="Profile Details Modal|Profile update propagation warning@@profile-details-modal-update-propagation-warning">Please note that user profile update might take a few seconds to propagate across the system</span>
  </span>
  <span class="fill-space"></span>
  <app-button [disabled]="inProgress || schoolDataLoading"
              [secondary]="true"
              (clicked)="closeModal()"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button label="Save"
              i18n-label="General|Save action label@@general-save-action-label"
              [disabled]="inProgress || schoolDataLoading || !proceedAllowed()"
              (clicked)="proceed()"></app-button>
</div>
